import { Query } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { AbsencePlanerState, AbsencePlanerStore } from './absence-planer.store';
import { AbsencePlanerTimeframeEnum } from '../../enums/absence-planer-timeframe.enum';
import { DateRange } from '../../models/date-range';
import { map, Observable } from 'rxjs';
import { AbsencePlanerUserList } from '../../models/client-models';

@Injectable({
  providedIn: 'root',
})
export class AbsencePlanerQuery extends Query<AbsencePlanerState> {
  userList$ = this.select((state) => state.users);
  calendarItems$ = this.select((state) => state.calendarItems);
  grouping$ = this.select((state) => state.grouping);
  allAbsences$ = this.select((state) => state.allRequests);
  filter$ = this.select((state) => state.filter);
  filterID$ = this.select((state) => state.filterID);
  timeFrame$ = this.select((state) => state.selectedTimeFrame);
  editable$ = this.select(
    (state) =>
      state.selectedResource?.edit &&
      state.selectedDateVisumInfo?.dateCheck?.chronoLockDate?.successful &&
      state.selectedDateVisumInfo?.dateCheck?.yearOpen?.successful
  );

  selectedDateRange$ = this.select((state) => state.selectedDateRange);
  selectedResource$ = this.select((state) => state.selectedResource);
  visum$ = this.select((state) => state.selectedDateVisumInfo);
  requestedAbsences$ = this.select((state) => state.requestedAbsences);
  confirmationActive$ = this.select((state) => {
    if (!state.selectedResource.edit) {
      return false;
    }

    for (const item of state.requestedAbsences) {
      for (const absence of item.absences) {
        const startString = state.selectedDateRange.start.toString();
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const start = new Date(startString);

        const endString = state.selectedDateRange.end.toString();
        const end = new Date(endString);

        start.setHours(0);
        end.setHours(0);

        if (
          absence.idPerson === state.selectedResource.idPerson &&
          new Date(absence.datum) >= start &&
          new Date(absence.datum) <= end
        ) {
          return true;
        }
      }
    }
    return false;
  });

  constructor(protected store: AbsencePlanerStore) {
    super(store);
  }

  getAllRequests(): boolean {
    return this.store.getValue()?.allRequests;
  }

  selectFilter(): Observable<number> {
    return this.select((state) => state.filter);
  }

  selectFilterID(): Observable<number> {
    return this.select((state) => state.filterID);
  }

  getGrouping(): number {
    return this.store.getValue()?.grouping;
  }

  getFilter(): number {
    return this.store.getValue()?.filter;
  }

  getFilterID(): number {
    return this.store.getValue()?.filterID;
  }

  getTimeFrame(): AbsencePlanerTimeframeEnum {
    return this.store.getValue()?.selectedTimeFrame;
  }

  getDateRange(): DateRange {
    return this.store.getValue()?.selectedDateRange;
  }

  getSelectedResource(): AbsencePlanerUserList {
    return this.store.getValue()?.selectedResource;
  }

  getVisibleDateRange(): DateRange {
    return this.store.getValue()?.visibleDateRange;
  }

  getSettings(): any {
    return {
      grouping: this.store.getValue()?.grouping,
      filter: this.store.getValue()?.filter,
      filterID: this.store.getValue()?.filterID,
    };
  }

  selectAbsenceCount(): Observable<number> {
    return this.requestedAbsences$.pipe(map((list) => list.length));
  }
}
